// 攝影機「事件」分頁：同一次的「開始 / 結束」合成一列「偵測到移動 13:58（持續 12 秒）」（第五輪 R5-P2-2）。
// 配對跟事件與警報清單、事件詳細同一個函式（lib/eventEpisodes，第八輪 R8-P1-1：façade 的 phase 是 started / ended，
// 原本只認 start / end 所以從來沒配起來；同一個 device_ref＋binding_id＋key、開始配之後第一個結束）。
import { mergeEpisodeRows, phaseOf, type Episode } from '../../lib/eventEpisodes';

export interface PhaseEvent {
  event_id: string;
  key: string;
  occurred_at: string;
  phase?: string | null;
  thing?: { device_ref?: string };
  scope?: unknown;
}

export interface PhaseRow<E> {
  e: E;
  /** 跟「結束」配成一列時的持續秒數 */
  durSec?: number;
  ep?: Episode;
}

export function pairPhases<E extends PhaseEvent>(list: E[]): PhaseRow<E>[] {
  return mergeEpisodeRows(list, (e) => {
    const phase = phaseOf({ phase: e.phase ?? undefined });
    if (!phase) return null;
    const b = (e.scope as { binding_id?: unknown } | undefined)?.binding_id;
    return { id: e.event_id, ts: Date.parse(e.occurred_at), phase, ref: e.thing?.device_ref ?? '', binding: typeof b === 'string' && b ? b : undefined, key: e.key };
  }).map(({ r, ep }) => {
    if (!ep) return { e: r };
    const sec = ep.start && ep.end ? Math.round((ep.end.ts - ep.start.ts) / 1000) : undefined;
    return sec !== undefined ? { e: r, durSec: sec, ep } : { e: r, ep };
  });
}
